import classNames from 'classnames';
import { AddIcon } from 'tdesign-icons-react';
import { Button, Tooltip } from 'tdesign-react';

import { ActionType, EventToolBarType, EventType, MissionType, PLAY_INFO_ID, RELATEDMESSAGE, SenderType } from '@/const/mission';
import { IEvents } from '@/interface';

import { eventDefaultValue } from './default';
import styles from './index.module.less';
import { EVENT_TOOLBAR_BORDER, ToolbarItem } from './toolbar';

interface IProps {
  onChange: (value: any) => void;
  values: IEvents[];
  fieldname: string;
  disabled: boolean;
  botList: { name: string, id: string }[];
  missionType: MissionType;
  toolBar?: ToolbarItem[];
  addText?: string;
}

const EventToolBar: React.FC<IProps> = (props) => {
  const { onChange, disabled, botList, toolBar = [], addText = '', values = [], fieldname } = props;

  const handleAddItem = (key: string, disabledItem: boolean) => {
    if (disabledItem || disabled) {
      return;
    }
    addItem(key);
  };

  const addItem = (key: string) => {
    if (disabled) return;
    let defaultValue = eventDefaultValue?.[key];
    if (key === EventToolBarType.ADD_BOT) {
      defaultValue = setDefaultBot(defaultValue);
    }
    onChange(defaultValue);
  };

  const setDefaultBot = (botEvent: IEvents) => {
    if (botEvent?.message?.sender?.type === SenderType.BOT && !botEvent?.message?.sender?.senderId) {
      let sender = {
        type: botList?.[0]?.id === PLAY_INFO_ID ? SenderType.USER : SenderType.BOT,
        senderId: botList?.[0]?.id || '',
      };
      if (fieldname === RELATEDMESSAGE && botList?.[0]?.id === PLAY_INFO_ID) {
        sender = {
          type: SenderType.BOT,
          senderId: '',
        };
      }
      return {
        ...botEvent,
        message: {
          ...botEvent?.message,
          sender,
        },
      };
    }
    return botEvent;
  };

  const hasExcl = values?.filter(e => e.type === EventType.EVENT_TYPE_EXCL)?.length > 0;
  const hasGuide = values?.filter(e => e?.action?.type === ActionType.ACTION_TYPE_GUIDEREPLY)?.length > 0;

  return (
    <Tooltip
      overlayClassName={styles.toolbarTooltip}
      trigger="click"
      placement="right"
      showArrow
      destroyOnClose
      content={
        <div className={styles.toolbar}>
          < div className={styles.innerBar} >
            {toolBar?.map((e, i) => {
              const lastCls = i === toolBar?.length - 1 ? styles.last : '';
              if (e?.key === EVENT_TOOLBAR_BORDER) {
                return <div key={i} className={styles.line}></div>;
              }
              let disabledItem = disabled;
              if ((hasExcl && e?.key === EventToolBarType.ADD_DRAWER)
                || (hasGuide && e?.key === EventToolBarType.ADD_GUIDE_REPLAY)
              ) {
                disabledItem = true;
              }
              return (
                <div key={i}
                  className={classNames(
                    'nova-toolbar',
                    styles.bar,
                    styles[e.key],
                    lastCls,
                    { ['nova-disabled']: disabledItem },
                    { [styles.disabled]: disabledItem },
                  )
                  }
                  onClick={() => handleAddItem(e.key, disabledItem)}>
                  <span className={styles.icon}>{e?.icon}</span>
                  <span className={styles.label}>{e?.label}<span>
                  </span></span>
                </div>
              );
            })}
          </div >
        </div >
      }>
      <Button
        className={classNames(
          styles.add,
          { [styles.addText]: addText },
          { 'nova-disabled-opacity': disabled },
        )}
        theme="default"
        disabled={disabled}
      >
        <AddIcon />{addText}
      </Button>
    </Tooltip >
  );
};

export default EventToolBar;
